import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.5 6.042h15c0-.92-.747-1.667-1.667-1.667H4.167c-.92 0-1.667.747-1.667 1.667m0 .833v7.5c0 .92.747 1.667 1.667 1.667h11.666c.92 0 1.667-.748 1.667-1.667v-7.5zm1.667 7.221c0-.768.622-1.388 1.388-1.388h3.057c.768 0 1.388.623 1.388 1.388a.28.28 0 0 1-.279.279H4.445a.28.28 0 0 1-.278-.279m2.916-2.221c-.919 0-1.666-.747-1.666-1.667 0-.919.747-1.666 1.666-1.666.92 0 1.667.747 1.667 1.666 0 .92-.747 1.667-1.667 1.667m4.584-2.917c0-.229.187-.416.416-.416h3.334c.229 0 .416.187.416.416 0 .23-.187.417-.416.417h-3.334a.42.42 0 0 1-.416-.417m0 1.667c0-.23.187-.417.416-.417h3.334a.418.418 0 0 1 0 .833h-3.334a.42.42 0 0 1-.416-.416m0 1.667c0-.23.187-.417.416-.417h3.334c.229 0 .416.188.416.417s-.187.416-.416.416h-3.334a.42.42 0 0 1-.416-.416"
    }, null, -1)
  ]))]))
}
export default { render: render }